import { CurrencyPipe, registerLocaleData } from "@angular/common";
import es from "@angular/common/locales/es";
import { Inject, Injectable, Optional } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Account, AccountType, BuyAtNavIndicator, ContributionType, RedemptionFeeWaiver, TradeType, TradingEntitlements, TradingOrderBase, TransactionType } from "../../models";
import { getValueOrEmptyString } from "../../utils";
import { DatePipe } from '@angular/common';


@Injectable()
export class MutualFundTradingUtils {
    buyRedeem: string[] = ['Buy','Redeem','Redeem All'];
    datePipe: DatePipe = new DatePipe('en-US');
    currencyPipe: CurrencyPipe = new CurrencyPipe('en-US');
    commaDelimiterRE: RegExp = /\B(?=(\d{3})+(?!\d))/g;
    loadTypeCodes = ['N','X','B','D','L'];
    noLoadFundCode = ['N','X'];
    loadFundCodes = ['B','D','L'];
    ntfParticipantCodes = ['R','I','O'];
    ntfNonParticipantCodes = ['N','U',' '];
    linebreak = (navigator.appVersion.indexOf("Win") != -1)?'\r\n':'\n';
    constructor(private translateService: TranslateService, @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings?.language === 'es') {
            registerLocaleData( es );
        }
    }

    public showBuyAtNavFirst(loadNoLoadInd:string,transactionType:string,entitlements:TradingEntitlements): boolean {
        return this.noLoadFundCode.includes(loadNoLoadInd) && entitlements.isBdUser && transactionType==='Buy';
      }

    private isRedeemOrder(transactionType: TransactionType): boolean {
        return TransactionType.REDEEM === transactionType || TransactionType.REDEEM_ALL === transactionType;
    }

    public getAccountName(account:Account,accountName:string): string {
        //FIXME -- most likely need to pull out to common library
        return 'Account: ' + accountName +(!!account.ip?'   /   ' +' IP#: ' + getValueOrEmptyString(account.ipName) + account.ip:'');
    }

    public getOrderTitleStyleColor(orderTitleStyle:string):string {
        //FIXME -- most likely need to pull out to common library
        let color:string='black';
        if(orderTitleStyle === 'tr-OrderTitle_Buy') {
            color = '#008338';
        } else if(orderTitleStyle === 'tr-OrderTitle_Sell') {
            color = '#d81b60'
        }
        return color;    
    }

    public getOrderProcessing(isOrderSuccessfullySubmitted: boolean): string {
        //FIXME -- most likely need to pull out to common library
        let _orderProcessing = '';
        if (isOrderSuccessfullySubmitted) {
          _orderProcessing = 'The following Order has been sent for Processing';
        }
        return _orderProcessing;
    }

    public getOrderStatus(isOrderSuccessfullySubmitted:boolean, hasViolations:boolean,title:string): string {
        let _orderstatus = title;
        if (!isOrderSuccessfullySubmitted && !hasViolations) {
            _orderstatus += ' Order Review';
        } else if (!isOrderSuccessfullySubmitted && hasViolations) {
            _orderstatus += ' Order Review';
        } else if (isOrderSuccessfullySubmitted) {
            _orderstatus += ' Order Confirmation';
        }
        return _orderstatus;
    }

    private isDateAvailable(orderDate:string,orderTime:string,orderAMPM:string,orderTimeZone:string): Boolean{
        //FIXME -- most likely need to pull out to common library
        return (!!orderDate && !!orderTime && !!orderAMPM && !!orderTimeZone);
    }

    private getEnteredBy(username:string,orderDate:string,orderTime:string,orderAMPM:string,orderTimeZone:string) {
        //FIXME -- most likely need to pull out to common library
        let enteredBy = '';
        if(!!username) {
            if(this.isDateAvailable(orderDate,orderTime,orderAMPM,orderTimeZone)) {
                enteredBy += '/ ';
            }
            enteredBy += 'Entered by ' + username;
        }
        return enteredBy;
    }

    public getOrderPlacedon(username:string, approvalRequired:boolean,orderDate:string,orderTime:string,orderAMPM:string,orderTimeZone:string): string {
        //FIXME -- most likely need to pull out to common library
        let _orderPlacedon = '';
        if (this.isDateAvailable(orderDate,orderTime,orderAMPM,orderTimeZone)) {
            if (!approvalRequired) {
                _orderPlacedon = 'Order successfully submitted on ' + orderDate + ' at ' + orderTime + ' ' + orderAMPM + ' ' + orderTimeZone + this.getEnteredBy(username,orderDate,orderTime,orderAMPM,orderTimeZone);
    
            } else {
                _orderPlacedon = 'Order submitted for approval on ' + orderDate + ' at ' + orderTime + ' ' + orderAMPM + ' ' + orderTimeZone + this.getEnteredBy(username,orderDate,orderTime,orderAMPM,orderTimeZone);
            }
    
        } else {
            _orderPlacedon = this.getEnteredBy(username,orderDate,orderTime,orderAMPM,orderTimeZone);
        }
        return _orderPlacedon;
    }

    public getTransactionType(transactionType: string): string {
        switch (transactionType) {
            case TransactionType.BUY: return 'Buy';
            case TransactionType.REDEEM: return 'Redeem';
            case TransactionType.REDEEM_ALL: return 'Redeem All';
            case TransactionType.EXCHANGE: return 'Exchange';
            case TransactionType.EXCHANGE_ALL: return 'Exchange All';
            case TransactionType.SELL_AND_BUY: return 'Sell and Buy';
            case TransactionType.SELL_ALL_AND_BUY: return 'Sell All and Buy';
            default:
                return '';
        }
    };

    private splitRegExFixed(value:number) {
        let split:string[]=[];
        if (value === null || value === undefined) {
            return '';
        }
        if (value === 0 || !!value) {
          split = value.toFixed(2).split('.');
        }
        let split0 = '';
        let split1 = '';
        let decimal = '';
        if (!!split[0]) {
            split0 = split[0];
        }
        if (!!split[1]) {
          split1 = split[1];
          decimal = '.';
        }
        return (split0).replace(this.commaDelimiterRE, ',') + decimal + split1;
    }

    private splitRegExUnFixed(value:number) {
        let split:string[]=[];
        if (value === 0) {
            return '0.00';
        }
        if (!!value) {
          split = value.toString().split('.');
        }
        let split0 = '';
        let split1 = '';
        let decimal = '';
        if (!!split[0]) {
            split0 = split[0];
        }
        if (!!split[1]) {
          split1 = split[1];
          decimal = '.';
        }
        return (split0).replace(this.commaDelimiterRE, ',') + decimal + split1;
    }

    public getQuantity(order: any): string {
        let _quantity = '';
        if (order.tradeInShares) {
            _quantity = this.splitRegExUnFixed(order.shareQty) + ' Share(s)';
        } else {
            _quantity = '$' + this.splitRegExFixed(order.dollarQty);
        }
        return _quantity;
    }

    private orderDescriptionForBuyRedeemOrders(order:any,description:string,currencyCode:string,nonDollar:boolean): string {
        let _orderDescription = '';
        if (order.tradeInShares) {
            _orderDescription = description + ' ' + this.splitRegExUnFixed(order.shareQty) + ' Share(s) of ' + order.quote.symId;
        } else {
            if (!nonDollar || (currencyCode === 'USD')) {
                _orderDescription = description + ' $' + this.splitRegExFixed(order.dollarQty) + ' of ' + order.quote.symId;
            } else {
                _orderDescription = description + ' ' + currencyCode + this.splitRegExFixed(order.dollarQty) + ' of ' + order.quote.symId;
            }
        }
        return _orderDescription;
    }

    private orderDescriptionForNonBuyRedeemOrders(order:any,description:string,currencyCode:string,nonDollar:boolean): string { 
        let _orderDescription = '';
        if (order.tradeInShares) {
            _orderDescription = description + ' ' + this.splitRegExUnFixed(order.shareQty) + ' Share(s) From ' + order.quote.symId + ' To ' + (order.exchangeMutualFund?.symbol || order.exchangeMutualFund?.cusip);
        } else {
            if (!nonDollar || (currencyCode === 'USD')) {
                _orderDescription = description + ' $' + this.splitRegExFixed(order.dollarQty) + ' From ' + order.quote.symId + ' To ' + (order.exchangeMutualFund?.symbol || order.exchangeMutualFund?.cusip);
            } else {
                _orderDescription = description + ' ' + currencyCode + this.splitRegExFixed(order.dollarQty) + ' From ' + order.quote.symId + ' To ' + (order.exchangeMutualFund?.symbol || order.exchangeMutualFund?.cusip);
            }
        }
        return _orderDescription;
    }

    public getOrderDescription(order: any,currencyCode:string,nonDollar:boolean): string {
        let _orderDescription = this.getTransactionType(order.transactionType);
        
        if (this.buyRedeem.includes(_orderDescription)) {
            _orderDescription = this.orderDescriptionForBuyRedeemOrders(order,_orderDescription,currencyCode,nonDollar);
        } else {
            _orderDescription = this.orderDescriptionForNonBuyRedeemOrders(order,_orderDescription,currencyCode,nonDollar);
        }
        return _orderDescription;
    }

    public getQuoteDescription(order: any): string {
        let _quoteDescription = '';
        if (!!order.quote?.description) {
            _quoteDescription = order.quote.description.toString().replace(/\t/g, '').split(this.linebreak).toString()
        } else if (!!order.mutualFund?.fundName) {
            _quoteDescription = order.mutualFund.fundName.toString().replace(/\t/g, '').split(this.linebreak).toString()
        }
        return _quoteDescription
    }
    
    public getQuoteDescriptionCusip(order: any): string {
        let _quoteDescriptionCusip = '';
        let _quoteDescription = '';
        if (!!order.quote?.cusipId) {
            _quoteDescriptionCusip = this.getQuoteDescription(order).trim() + ' - ' + order.quote.cusipId;
        } else if (!!order.mutualFund?.cusip) {

            _quoteDescriptionCusip = this.getQuoteDescription(order).trim() + ' - ' + order.mutualFund.cusip;
        }
    
        return _quoteDescriptionCusip;
    }

    public getQuoteDescriptionForNonBuyRedeem(order: any): string {
        let _quoteDescription = '';
        if (!!order.exchangeMutualFund?.fundName) {
            _quoteDescription = order.exchangeMutualFund.fundName.toString().replace(/\t/g, '').split(this.linebreak).toString()
        }
        return _quoteDescription
    }

    public getQuoteDescriptionCusipForNonBuyRedeem(order: any): string {
        let _quoteDescriptionCusip = '';
        let _quoteDescription = '';
        if (!!order.exchangeMutualFund?.cusip) {
            _quoteDescriptionCusip = this.getQuoteDescriptionForNonBuyRedeem(order).trim() + ' - ' + order.exchangeMutualFund.cusip;
        }
    
        return _quoteDescriptionCusip;
    }

    public getBuyAtNav(buyAtNav:BuyAtNavIndicator) {
        switch (buyAtNav) {
            case 'NO': return 'None';
            case 'YES_OTHERS': return 'Other';
            case 'YES_NAV_TRANSFER': return 'Net Asset Value Transfer';
            case 'YES_REPURCHASES': return 'Repurchase';
            case 'YES_EMPLOYEE_REP': return 'Employee/Rep';
            case 'YES_ERROR_CORRECTION': return 'Error Correction';
            case 'YES_WRAP_FEE_ACCT': return 'Wrap Fee Account';
            case 'YES_NAV_COMMISSIONABLE': return 'NAV Commissionable';
            case 'YES_COMM_DEFINED_CONTRIBUTION_PLAN': return 'Commissionable Defined Contribution Plan';
            case 'YES_NON_COMM_DEFINED_CONTRIBUTION_PLAN': return 'Non-Commissionable Defined Contribution Plan';
            case 'YES_DIVIDEND_REINVESTMENT_TRADE': return 'Dividend Reinvestment Trade';
            case 'YES_TRUST_ACCT': return 'Trust Account';
            case 'YES_SELF_DIRECTED': return 'Self Directed';
            case 'YES_529_ACCT_QUALIFIED': return '529 Account Qualified Tuition Program';
            default:
                return '';
        }
    }

    public getEligibleToBuyAtNav(order:any,entitlements:TradingEntitlements) {
        let _eligibleToBuyAtNav = '';
        if (order.mutualFund.loadNoLoadInd === 'L' && entitlements.isBdUser && this.getTransactionType(order.transactionType) === 'Buy') {
            _eligibleToBuyAtNav = order.buyAtNav === BuyAtNavIndicator.NO ? 'No' : 'Yes';
        }
        return _eligibleToBuyAtNav
    }
    

    public getLoiValue(order:any,entitlements:TradingEntitlements) {
        let _loiValue = '';
        if (this.getEligibleToBuyAtNav(order,entitlements)==='No' && order.loiRoaIndicator === 'LOI_DATE') {
            _loiValue = this.splitRegExFixed(order.loiRoaValue);
        }

        return _loiValue;
    }

    public getLoiDate(order:any,entitlements:TradingEntitlements) {
        let _loiDate = '';
        if (this.getEligibleToBuyAtNav(order,entitlements)==='No' && order.loiRoaIndicator === 'LOI_DATE') {
            _loiDate = this.formatBackendDate(order.loiDate);
        }

        return _loiDate
    }

    public getRoaValue(order:any,entitlements:TradingEntitlements) {
         let _roaValue = '';
         if (this.getEligibleToBuyAtNav(order,entitlements)==='No' && order.loiRoaIndicator === 'ROA') {
             _roaValue = this.splitRegExFixed(order.loiRoaValue);
         }
 
         return _roaValue;
     }
    

    
    public getDvre(order:any) {
        let _dvre = '';
        if (!this.isRedeemOrder(order.transactionType)) {
            switch (order.dvre) {
                case 'CASH': return 'Cash';
                case 'REINVEST': return 'Reinvest Dividends & Capital Gains';
                case 'DIVIDEND': return 'Reinvest Dividends Only';
                case 'CAPITAL': return 'Reinvest Capital Gains Only';
                case 'CASH_NOTE': return 'Dividends & Capital Gains will be paid out in cash';
                case 'REINVEST_NOTE': return 'Dividends & Capital Gains will be reinvested';
                case 'DIVIDEND_NOTE': return 'Dividends will be reinvested and Capital Gains will be paid out in cash';
                case 'CAPITAL_NOTE': return 'Dividends will be paid out in cash and Capital Gains will be reinvested';
                case 'NOTE_LABEL': return 'Note:';
                default:
                    return '';
            }
        }
        return _dvre;
    }

    public getSolicited(order:any,entitlements:TradingEntitlements) {
        //FIXME -- most likely need to pull part of this out to common library
        let _solicited = '';
        if(entitlements.isBdUser && 
            (
                (this.getTransactionType(order.transactionType) === 'Buy' && this.loadTypeCodes.includes(order.mutualFund.loadNoLoadInd)) || 
                (this.getTransactionType(order.transactionType) !== 'Buy' && !!this.getTransactionType(order.transactionType))
                )) {
            switch (order.solicited) {
                case true: return 'Yes';
                case false: return 'No';
                case 'true': return 'Yes';
                case 'false': return 'No';
                case 'advised': return 'Was recommended';
                case 'notAdvised': return 'Was Not recommended';
                case 'advisedByProfessional': return 'Yes, this order was recommended by my investment professional/rep.';
                default:
                    return '';
            }
        }
        return _solicited;
    }
    
    public getShareClassReviewed(order:any,entitlements:any) {
        let _shareClassReviewed = '';
        if(entitlements.isBdUser && this.getTransactionType(order.transactionType) === 'Buy' && this.loadFundCodes.includes(order.mutualFund.loadNoLoadInd) && entitlements.isMutualFundShareClassReviewEnabled && !!order.shareClassReviewed) {
            if (order.shareClassReviewed === 'Y') {
                _shareClassReviewed = 'Yes';
            } else if (order.shareClassReviewed === 'N'){
                _shareClassReviewed = 'No';
            }
        }
        return _shareClassReviewed;
    }

    public getBalanceType(order:any) {
        let _balanceType = '';
        if (order.tradeType !== TradeType.PLAN_529FUND && order.account.custodianCd === 'BNYM') {
            if (order.balTypeCd.trim() === 'PRINCIPAL') {
                _balanceType = 'Principal';
            } else if (order.balTypeCd.trim() === 'INCOME') {
                _balanceType = 'Income'
            }
        }
        return _balanceType;
    }

    public getAccountType(order: any,isMultiPositionRedeemOrExchange:boolean): string {
        //FIXME -- most likely need to pull part of this out to common library
        if (this.getTransactionType(order.transactionType)!== 'Buy') {
            if (!!isMultiPositionRedeemOrExchange) {
                return 'Cash, Margin';
            }
            else {
                switch (order.accountType) {
                    case AccountType.CASH:
                        return 'Cash';
                    case AccountType.MARGIN:
                        return 'Margin';
                    case AccountType.SHORT:
                        return 'Short';
                    case AccountType.COD:
                        return 'COD';
                    case AccountType.RETIREMENT:
                        return 'Retirement';
                    case AccountType.PRINCIPAL:
                        return 'Principal';
                    case AccountType.INCOME:
                        return 'Income';
                    default:
                        return '';
                }
            }
        }
        return '';
    }


    public getFundCutoffTime(order: any) {
        if ( this.buyRedeem.includes(this.getTransactionType(order.transactionType)) && !!order.mutualFund ) {
            let date = new Date('1970-01-01T' + order.mutualFund.purchaseCutoffTime + '-05:00');
            return this.datePipe.transform(date,'hh:mm aa', '-0500') + ' ET';
        } else {
            return '';
        }
    }

    public getFundVestDerivedVal(order: any) {
        if (this.buyRedeem.includes(this.getTransactionType(order.transactionType))){
            if (this.ntfParticipantCodes.includes(order.mutualFund?.ntfParticipationCode)) {
                return 'Yes';
            } else if (this.ntfNonParticipantCodes.includes(order.mutualFund?.ntfParticipationCode)) {
                return 'No';
            } else {
                return 'N/A';
            }
        } else {
            return ''
        }
    }

    public getRedemptionFeeWaiver(order:any,entitlements:TradingEntitlements) {
        if ((entitlements.isBdUser && !!order.redemptionFeeWaiver) || (entitlements.isRiaUser && this.isRedeemOrder(order.transactionType))) {
            switch(order.redemptionFeeWaiver) {
                case RedemptionFeeWaiver.NO:
                    return 'No';
                case RedemptionFeeWaiver.DUE_TO_CORRECTION:
                    return 'Due to Correction';
                case RedemptionFeeWaiver.DUE_TO_DEATH:
                    return 'Due to Death';
                case RedemptionFeeWaiver.DUE_TO_DISABILITY:
                    return 'Due to Disability';
                case RedemptionFeeWaiver.DUE_TO_MANDATORY_DISTRIBUTION:
                    return 'Due to Mandatory Distribution';
                case RedemptionFeeWaiver.DUE_TO_DEFINED_CONTRIBUTION:
                    return 'Due to Defined Contribution';
                case RedemptionFeeWaiver.DUE_TO_HARDSHIP:
                    return 'Due to Hardship';
                case RedemptionFeeWaiver.DUE_TO_AUTO_REBALANCE:
                    return 'Due to Auto Rebalance';
                case RedemptionFeeWaiver.DUE_TO_DC_TERMINATION_DISTRIBUTION:
                    return 'Due to DC - Termination Distribution';
                case RedemptionFeeWaiver.DUE_TO_DC_INVOLUNTARY_DISTRIBUTION:
                    return 'Due to DC - Involuntary Distribution';
                case RedemptionFeeWaiver.DUE_TO_DC_FORFEITURES:
                    return 'Due to DC - Forfeitures';
                case RedemptionFeeWaiver.DUE_TO_DC_LOANS:
                    return 'Due to DC - Loans';
                case RedemptionFeeWaiver.DUE_TO_DC_EXCESSIVE_CONTRIBUTIONS:
                    return 'Due to DC - Excessive Contributions';
                case RedemptionFeeWaiver.DUE_TO_FUND_OF_FUNDS:
                    return 'Due to Fund of Funds';
                case RedemptionFeeWaiver.DUE_TO_DIVORCE_QDRO:
                    return 'Due to Divorce/QDRO';
                case RedemptionFeeWaiver.DUE_TO_PLAN_FEES_QDRO:
                    return 'Due to Plan Fees QDRO';
                default:
                    return '';
            }
        } else {
            return '';
        }
    };

    public getShortSettle(order:any,entitlements:TradingEntitlements) {
        if ((entitlements.isRiaUser && entitlements.isMutualFundShortSettleEnabled && this.isRedeemOrder(order.transactionType) && !!order.shortSettle && order.mutualFund?.shortSettlementReasonCode === 'Y') || (entitlements.isBdUser && !!order.shortSettle)) {
            switch (order.shortSettle) {
                case 'Y':
                    return 'Yes';
                case 'N':
                    return 'No';
                default:
                    return '';
            }
        } else {
            return '';
        }
    }

    public getTrailer(trailer: string) {
        return trailer;
    };

    public getAsOfDate(valueDate: string) {
        return valueDate;
    }

    public getErrAcctNum(zipCd:string) {
        return zipCd;
    }

    public getDiscExercised(order:any) {
        let _discExercised = '';
        if(!!order.discExercised.trim() && (this.getTransactionType(order.transactionType) === 'Buy' && (this.loadTypeCodes.includes(order.mutualFund.loadNoLoadInd))) || (this.getTransactionType(order.transactionType) !== 'Buy' && !!this.getTransactionType(order.transactionType))) {
            if (order.discExercised.trim() === 'Y') {
                _discExercised = 'Yes';
            } else if (order.discExercised.trim() === 'N'){
                _discExercised = 'No';
            }
        }
        return _discExercised;
    }


    public getAddlOrdData(addlOrdData: any): string {
        //FIXME -- most likely need to pull part of this out to common library
        let _addlOrdData = '';
        if (!!addlOrdData) {
            for (let tradeCondition of addlOrdData) {
                _addlOrdData = _addlOrdData + this.getTradeCondition(tradeCondition) + ',';
            }
        }
        return _addlOrdData.substring(0,_addlOrdData.length-1);
    }
    
    private getTradeCondition(tradeCondition: string): string {
        //FIXME -- most likely need to pull part of this out to common library
        switch (tradeCondition) {
            case 'AON':
                return 'All Or None';
            case 'NOTHELD':
                return 'Not Held';
            case 'DONOTINCREASE':
                return 'Do Not Increase Shares';
            case 'DONOTREDUCE':
                return 'Do Not Reduce Price';
            case 'NEXTDAY':
                return 'Next Day';
            case 'CASHSAMEDAY':
                return 'Cash - Same Day Settlement';
            case 'EXECUTEASAGENT':
                return 'Execute As Agent';
            default:
                return '';
        }
    }

    public getFloorInst(floorInst: string): string {
        //FIXME -- most likely need to pull part of this out to common library
        switch (floorInst) {
            case '10% POV': return '10% Percentage of Volume (POV)';
            case '15% POV': return '15% Percentage of Volume (POV)';
            case '25% POV': return '25% Percentage of Volume (POV)';
            case '33% POV': return '33% Percentage of Volume (POV)';
            case 'EXECUTE HALF NOW,WRK HALF': return 'Execute half now, work half';
            case 'NO NEED TO COMPLETE': return 'No need to complete';
            case 'PLS WAIT FOR FURTHER INST': return 'Please wait for further instructions';
            case 'TWAP': return 'Time Weighted Average Price (TWAP)';
            case 'VWAP': return 'Volume Weighted Average Price (VWAP)';
            case 'VWAP OVER 2 HOURS': return 'Volume Weighted Avg Price > 2 hours (VWAP)';
            case 'VWAP OVER 3 HOURS': return 'Volume Weighted Avg Price > 3 hours (VWAP)';
            case 'WORK NOT HELD': return 'Work Not Held';
            case 'INSIDER ACCOUNT': return 'Insider account';
            case 'NON REPORT INSIDER/ASSOC': return 'Non report insider/assoc';
            case 'PROMOTOR INSIDER RELATION': return 'Promotor Insider Relation';
            case 'REPORTING INSIDER': return 'Reporting insider';
            case 'SIGNIFICANT SHRHLDR(>20%)': return 'Significant Shareholder (>20%)';
            default:
                return '';
        }
    }

    formatBackendTime(sourceTime: string): string { //aabbcccccc -> aa:bb:ccccc
        //FIXME -- most likely need to pull part of this out to common library
        if ( !!sourceTime && sourceTime !== '' ) {
            return sourceTime.substring(0, 2) + ':' + sourceTime.substring(2, 4) + ':' + sourceTime.substring(4);
        } else {
            return sourceTime;
        }
    }

    formatBackendDate(sourceDate: string, origOrder?:TradingOrderBase): string {     // yyyymmdd => mm/dd/yyyy
        //FIXME -- most likely need to pull part of this out to common library
        if (!!origOrder && !!sourceDate) {
            return sourceDate.substring(4, 6) + '/' + sourceDate.substring(6, 8) + '/' + sourceDate.substring(0, 4);
        } else if(!!sourceDate){
            return sourceDate
        } else {
            return '';
        }
    }

    public getContributionType(order:any,account:Account) {
        if (order.tradeType === TradeType.PLAN_529FUND && order.transactionType === TransactionType.BUY && !account.beingTradedInLevel4PlanAcct) {
            switch(order.contributionType) {
                case 'CURRENT_YEAR': return 'Current Year';
                case 'PRIOR_YEAR': return 'Prior Year';
                case 'ROLLOVER': return 'Rollover';
                default: return '';
            }
        }
        else {return ''};
    }

    public getOriginalContribution(order:any,account:Account) {
        if (order.tradeType===TradeType.PLAN_529FUND && order.transactionType === TransactionType.BUY && !account.beingTradedInLevel4PlanAcct) {
            if (order.contributionType && order.contributionType === ContributionType.ROLLOVER) {
                let orderAmountCurrency = !!order.mutualFund?.currencyCode && order.mutualFund.currencyCode !== 'USD' ? order.mutualFund.currencyCode : 'USD';
                return this.currencyPipe.transform(order.originalContribution,orderAmountCurrency,(orderAmountCurrency === 'USD' ? 'symbol':'code'), '1.2-4');
            } else {return ''}
        } else {return ''}
    }
  
    public getEarningsType(order:any,account:Account) {
        if (order.tradeType === TradeType.PLAN_529FUND && order.transactionType === TransactionType.BUY && !account.beingTradedInLevel4PlanAcct) {
            if (order.contributionType && order.contributionType === ContributionType.ROLLOVER) {
                switch(order.earningsType) {
                    case 'GAIN': return 'Gain';
                    case 'LOSS': return 'Loss';
                    default: return '';
                }
            } else {return ''}
        } else {return ''}
    }

    public getEarningsAmount(order:any,account:Account) {
        if (order.tradeType === TradeType.PLAN_529FUND && order.transactionType === TransactionType.BUY && !account.beingTradedInLevel4PlanAcct) {
            if (order.contributionType && order.contributionType === ContributionType.ROLLOVER) {
                let orderAmountCurrency = !!order.mutualFund?.currencyCode && order.mutualFund.currencyCode !== 'USD' ? order.mutualFund.currencyCode : 'USD';
                return this.currencyPipe.transform(order.earningsAmount,orderAmountCurrency,(orderAmountCurrency === 'USD' ? 'symbol':'code'), '1.2-4');
            } else {return ''}
        } else {return ''}
    }

    public getDistributionType(order:any,account:Account) {
        if (order.tradeType === TradeType.PLAN_529FUND && this.isRedeemOrder(order.transactionType) && !account.beingTradedInLevel4PlanAcct) {
            switch(order.distributionType) {
                case 'QUALIFIED': return 'Qualified';
                case 'NON_QUALIFIED': return 'Non Qualified';
                case 'ROLLOVER': return 'Rollover';
                default: return '';
            }
        } else {return ''}
    }

    public getPayToType(order:any,account:Account) {
        if (order.tradeType === TradeType.PLAN_529FUND && this.isRedeemOrder(order.transactionType) && !account.beingTradedInLevel4PlanAcct) {
            switch(order.payToType) {
                case 'ACCOUNT_HOLDER': return 'Account Holder';
                case 'BENEFICIARY': return 'Beneficiary';
                case 'ANOTHER_529_PROGRAM': return 'Another 529 Program';
                default: return '';
            }
        } else {return ''}
    }

    public getOverUnderIndicator(order:any,entitlements:TradingEntitlements) {
        if (entitlements.isBdUser && !!order.overUnderIndicator)  {
            switch(order.overUnderIndicator) {
                case 'OVER': return 'Over';
                case 'UNDER': return 'Under';
                default: return '';
            }
        } else return '';
    }

    public getDeliver(order:any,entitlements:TradingEntitlements) {
        if (order.tradeType !== TradeType.PLAN_529FUND && entitlements.isBdUser && this.loadFundCodes.includes(order.mutualFund?.loadNoLoadInd) && !!order.deliver) {
            switch(order.deliver) {
                case 'STREET': return 'Street';
                case 'FUND': return 'Fund';
                default: return '';
            }
        } else return ''
    }

    public getFundAccountNum(order:any,entitlements:TradingEntitlements) {
        let _fundAccountNum = ''
        if(entitlements.isBdUser && !!order.fundAccountNum) {
            _fundAccountNum = order.fundAccountNum
        }
        return _fundAccountNum
    }

    public getGrossNetIndicator(order:any,entitlements:TradingEntitlements) {
        if(entitlements.isBdUser && !!order.grossNetIndicator) {
            switch(order.grossNetIndicator) {
                case 'GROSS': return 'Gross';
                case 'NET': return 'Net';
                default: return ''
            }
        } else return ''
    }

    public getCdscWaiver(order:any,entitlements:TradingEntitlements) {
        if(entitlements.isBdUser && !!order.cdscWaiver) {
            switch(order.cdscWaiver) {
                case 'NO': return 'No';
                case 'DUE_TO_CORRECTION': return 'Due to Correction';
                case 'DUE_TO_DEATH' : return 'Due to Death';
                case 'DUE_TO_DISABILITY': return 'Due to Disability';
                case 'DUE_TO_MANDATORY_DISTRIBUTION': return 'Due to Mandatory Distribution';
                case 'DUE_TO_DEFINED_CONTRIBUTION': return 'Due to Defined Contribution';
                case 'DUE_TO_HARDSHIP' : return 'Due to Hardship';
                case 'DUE_TO_NO_COMMISSION_PAID': return 'Due to No Commission Paid';
                default: return ''
            }
        } else return ''
    }

    public getSourceOfFunds(order: any,entitlements:TradingEntitlements): string {
        //FIXME -- most likely need to pull part of this out to common library
        if(entitlements.isBdUser && entitlements.isMutualFundSourceOfFundsEnabled && !!order.sourceOfFunds && order.sourceOfFunds !== 'NONE') {
            switch(order.sourceOfFunds) {
                case 'CREDIT_BAL_MONEY_MKT':  return 'Account Credit Balance/Money Market';
                case 'MF_UIT_REDEMPTION': return 'MF/UIT Redemption';
                case 'ANNUITY_REDEMPTION': return 'Annuity Redemption';
                case 'NEW_MONIES': return 'New Monies';
                case 'OTHER_ADVISORY_ACCT': return 'Other Advisory Account';
                case 'ROLLOVER_QUALIFIED_ACCT': return 'Rollover/Qualified Account';
                case 'SECURITIES_LIQUIDATION': return 'Security Liquidation';
                default: return '';
            }
        } else return ''
    }


    public getSourceOfInput(order: any,entitlements:TradingEntitlements): string {
        //FIXME -- most likely need to pull part of this out to common library
        if (entitlements.isBdUser && entitlements.isSourceOfInputOverrideEnabled ) {
            switch (order.sourceOverride) {
                case '3':
                    return 'NetX360';
                case 'I':
                    return 'Web';
                case 'J':
                    return 'Interactive Voice Response';
                case 'K':
                    return 'Proprietary';
                case 'Z':
                    return 'Home Office';
                case 'Q':
                    return 'Wireless Client via NX';
                case 'R':
                    return 'Wireless Pro via NX';
                case 'A':
                    return 'External Advisor Site';
                case '5':
                    return 'External Mobile Site';
                default:
                    return '';
            }
        } else return '';
    }   

    public getMfInvestObjCode(order:any) {
        let attestation = '';
        if (!!order.mfInvestObjCode) {
            attestation = order.mfInvestObjCode === 'Y' ? 'Yes' : 'No'
        }
        return attestation;
    }

}